import { render, staticRenderFns } from "./TabInquired.vue?vue&type=template&id=9bbe6e50&"
import script from "./TabInquired.vue?vue&type=script&lang=js&"
export * from "./TabInquired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports